import React, { createContext, useContext } from 'react';
const RadioGroupsContext = createContext({
    variant: 'list',
});
export const RadioGroupsProvider = ({ variant, children }) => (React.createElement(RadioGroupsContext.Provider, { value: {
        variant,
    } }, children));
export const useRadioGroups = () => {
    const context = useContext(RadioGroupsContext);
    if (context === undefined) {
        throw new Error('useRadioGroups must be used within a RadioGroupsProvider');
    }
    return context;
};
//# sourceMappingURL=RadioGroupContext.js.map